"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var envProps = {
  0: false,
  1: true,
  2: function _(specialPrice) {
    return specialPrice !== null;
  }
};
var showLowestPrice = function showLowestPrice(_ref) {
  var showLowestPriceId = _ref.showLowestPriceId,
    price = _ref.price;
  if (price.lowest === null || price.lowest === undefined) return false;
  if (showLowestPriceId === 2) {
    return envProps[showLowestPriceId](price.special);
  }
  return envProps[showLowestPriceId];
};
var _default = showLowestPrice;
exports["default"] = _default;